export const DASHBOARD_PRESS_HOVER_BG_COLOR = 'Button/Light/Only Text';
